import { Dialog } from '@spiaggeit/spit-ui'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { ExclamationMark } from '@/assets/icons/ExclamationMark'
import { useAppSelector } from '@/hooks/store'
import { useMapSpotName } from '@/hooks/useMapSpotName'
import { licenseSlice } from '@/store/licenseSlice'
import { mapCurrentSectorSelector, mapSelectors } from '@/store/mapSlice'
import { DangerousHtml } from '../DangerousHtml/DangerousHtml'
import { Tooltip } from '../Tooltip/Tooltip'
import { RefundPolicy } from './RefundPolicy'

export const SelectedElementHeader = memo(
  function SelectedElementHeader() {
    const selectedElement = useAppSelector(mapSelectors.selectedElement)
    const currentSector = useAppSelector(mapCurrentSectorSelector)
    const { t } = useTranslation()
    const license = useAppSelector(licenseSlice.selectors.license)
    const notes = license?.bookingServicesNotes
    const { getMapSpotName } = useMapSpotName()
    const title = getMapSpotName(selectedElement)

    if (!selectedElement) {
      return null
    }

    return (
      <div className="relative z-10 border-b border-solid border-gray-200 px-4">
        <div className="flex items-stretch gap-2 pb-4 lg:sticky lg:top-0 lg:z-[80] lg:justify-between lg:bg-white">
          {currentSector?.header.image && (
            <img
              className="w-20 rounded-md object-cover"
              src={currentSector.header.image}
            />
          )}
          <div className="flex flex-col gap-2">
            <div className="flex justify-between">
              <Tooltip
                className="word-break mr-5 font-bold capitalize text-primary"
                content={title}
                maxLines={3}
                overflowStyle="no-underline"
                wrapper="h3"
              />
            </div>
            {notes && (
              <Dialog
                mobileMode="bottomSheet"
                scrollContent
                size="md"
                title={t('map.elementDetail.info')}
                trigger={
                  <button className="flex cursor-pointer items-center gap-1 self-start text-sm text-secondary underline">
                    {t('map.elementDetail.info')}
                    <ExclamationMark height={20} width={20} />
                  </button>
                }
              >
                <DangerousHtml
                  className="p-4 text-secondary"
                  html={notes.replace(/\n/g, '<br />')}
                />
              </Dialog>
            )}
            <RefundPolicy />
          </div>
        </div>
      </div>
    )
  },
  () => true
)
